import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  ExportPeopleForSelectorChunk,
  GetPeopleByRolesRequest,
  GetPeopleByRolesResponse,
  GetPeopleCollectionRequest,
  GetPeopleCollectionResponse,
  GetPeopleForSelectorRequest,
  GetPeopleForSelectorResponse,
  GetPeopleFromFileRequest,
  GetPeopleFromFileResponse,
  GetPersonByStudentIdRequest,
  GetPersonByStudentIdResponse,
  GetPersonRequest,
  GetPersonResponse,
  PeopleCollectionSummaryRequest,
  PeopleCollectionSummaryResponse,
  SearchPeopleCollectionRequest,
  SearchPeopleCollectionResponse,
} from '../people_collection/people_collection_pb';

import {
  PeopleCollection as __PeopleCollection,
} from '../people_collection/people_collection_pb_service';

@Injectable({providedIn: 'root'})
export class PeopleCollection {

  constructor(private _ngZone: NgZone) {
  }

  getPeopleCollection(request: GetPeopleCollectionRequest): {cancel():void;close():void}&Observable<GetPeopleCollectionResponse>;
  getPeopleCollection(request: GetPeopleCollectionRequest, metadata: grpc.Metadata): {cancel():void;close():void}&Observable<GetPeopleCollectionResponse>;
  getPeopleCollection(request: GetPeopleCollectionRequest, onMessage: (message?: GetPeopleCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;
  getPeopleCollection(request: GetPeopleCollectionRequest, metadata: grpc.Metadata, onMessage: (message?: GetPeopleCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;

  getPeopleCollection(request: GetPeopleCollectionRequest, arg1?: grpc.Metadata|((message?: GetPeopleCollectionResponse) => void), arg2?: ((message?: GetPeopleCollectionResponse) => void)|((err: any) => void), arg3?: ((err: any) => void)|((code: number, msg: string|undefined, metadata: grpc.Metadata) => void), arg4?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): {cancel():void;close():void}&Observable<GetPeopleCollectionResponse>|void {
    let ret: any;
    let metadata: any;

    let onMessage: any;
    let onError: any;
    let onEnd: any;
    if(typeof arg1 === 'function') {
      onMessage = arg1;
      onError = arg2;
      onEnd = arg3;
    } else if(typeof arg2 === 'function') {
      metadata = arg1;
      onMessage = arg2;
      onError = arg3;
      onEnd = arg4;
    } else {
      metadata = arg1;
    }

    if(!onMessage) {
      let subject = new Subject<GetPeopleCollectionResponse>();
      ret = subject.asObservable();

      onMessage = (response: any) => {
        subject.next(response);
      };

      onError = (err: any) => {
        subject.error(err);
      };

      onEnd = (code: any, msg: any, metadata: any) => {
        subject.complete();
      };

    } else {
      if(!onError) {
        onError = (err: any) => console.error(err);
      }

      if(!onEnd) {
        onEnd = (code: any, msg: any, metadata: any) => {};
      }
    }

    let req = grpc.invoke(__PeopleCollection.GetPeopleCollection, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onMessage: response => this._ngZone.run(() => {
        onMessage(response);
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code == grpc.Code.OK) {
          onEnd(code, msg, metadata);
        } else {
          let err = new Error(code + ' ' + (msg||''));
          (<any>err).code = code;
          onError(err);
        }
      })
    });

    (<any>ret).close = () => {
      console.warn('[Angular Grpc] .close() is deprecated use .cancel() instead');
      return req.close();
    };
    (<any>ret).cancel = () => req.close();
    return ret;
  }

  searchPeopleCollection(request: SearchPeopleCollectionRequest): {cancel():void;close():void}&Observable<SearchPeopleCollectionResponse>;
  searchPeopleCollection(request: SearchPeopleCollectionRequest, metadata: grpc.Metadata): {cancel():void;close():void}&Observable<SearchPeopleCollectionResponse>;
  searchPeopleCollection(request: SearchPeopleCollectionRequest, onMessage: (message?: SearchPeopleCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;
  searchPeopleCollection(request: SearchPeopleCollectionRequest, metadata: grpc.Metadata, onMessage: (message?: SearchPeopleCollectionResponse) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;

  searchPeopleCollection(request: SearchPeopleCollectionRequest, arg1?: grpc.Metadata|((message?: SearchPeopleCollectionResponse) => void), arg2?: ((message?: SearchPeopleCollectionResponse) => void)|((err: any) => void), arg3?: ((err: any) => void)|((code: number, msg: string|undefined, metadata: grpc.Metadata) => void), arg4?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): {cancel():void;close():void}&Observable<SearchPeopleCollectionResponse>|void {
    let ret: any;
    let metadata: any;

    let onMessage: any;
    let onError: any;
    let onEnd: any;
    if(typeof arg1 === 'function') {
      onMessage = arg1;
      onError = arg2;
      onEnd = arg3;
    } else if(typeof arg2 === 'function') {
      metadata = arg1;
      onMessage = arg2;
      onError = arg3;
      onEnd = arg4;
    } else {
      metadata = arg1;
    }

    if(!onMessage) {
      let subject = new Subject<SearchPeopleCollectionResponse>();
      ret = subject.asObservable();

      onMessage = (response: any) => {
        subject.next(response);
      };

      onError = (err: any) => {
        subject.error(err);
      };

      onEnd = (code: any, msg: any, metadata: any) => {
        subject.complete();
      };

    } else {
      if(!onError) {
        onError = (err: any) => console.error(err);
      }

      if(!onEnd) {
        onEnd = (code: any, msg: any, metadata: any) => {};
      }
    }

    let req = grpc.invoke(__PeopleCollection.SearchPeopleCollection, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onMessage: response => this._ngZone.run(() => {
        onMessage(response);
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code == grpc.Code.OK) {
          onEnd(code, msg, metadata);
        } else {
          let err = new Error(code + ' ' + (msg||''));
          (<any>err).code = code;
          onError(err);
        }
      })
    });

    (<any>ret).close = () => {
      console.warn('[Angular Grpc] .close() is deprecated use .cancel() instead');
      return req.close();
    };
    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getPerson(request: GetPersonRequest): Promise<GetPersonResponse>;
  getPerson(request: GetPersonRequest, metadata: grpc.Metadata): Promise<GetPersonResponse>;
  getPerson(request: GetPersonRequest, callback: (err: any|null, response: GetPersonResponse, metadata: grpc.Metadata) => void): void;
  getPerson(request: GetPersonRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPersonResponse, metadata: grpc.Metadata) => void): void;

  getPerson(request: GetPersonRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPersonResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPersonResponse, metadata: grpc.Metadata) => void): Promise<GetPersonResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPersonResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.GetPerson, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getPeopleByRoles(request: GetPeopleByRolesRequest): Promise<GetPeopleByRolesResponse>;
  getPeopleByRoles(request: GetPeopleByRolesRequest, metadata: grpc.Metadata): Promise<GetPeopleByRolesResponse>;
  getPeopleByRoles(request: GetPeopleByRolesRequest, callback: (err: any|null, response: GetPeopleByRolesResponse, metadata: grpc.Metadata) => void): void;
  getPeopleByRoles(request: GetPeopleByRolesRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPeopleByRolesResponse, metadata: grpc.Metadata) => void): void;

  getPeopleByRoles(request: GetPeopleByRolesRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPeopleByRolesResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPeopleByRolesResponse, metadata: grpc.Metadata) => void): Promise<GetPeopleByRolesResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPeopleByRolesResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.GetPeopleByRoles, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getPeopleForSelector(request: GetPeopleForSelectorRequest): Promise<GetPeopleForSelectorResponse>;
  getPeopleForSelector(request: GetPeopleForSelectorRequest, metadata: grpc.Metadata): Promise<GetPeopleForSelectorResponse>;
  getPeopleForSelector(request: GetPeopleForSelectorRequest, callback: (err: any|null, response: GetPeopleForSelectorResponse, metadata: grpc.Metadata) => void): void;
  getPeopleForSelector(request: GetPeopleForSelectorRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPeopleForSelectorResponse, metadata: grpc.Metadata) => void): void;

  getPeopleForSelector(request: GetPeopleForSelectorRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPeopleForSelectorResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPeopleForSelectorResponse, metadata: grpc.Metadata) => void): Promise<GetPeopleForSelectorResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPeopleForSelectorResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.GetPeopleForSelector, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  exportPeopleForSelector(request: GetPeopleForSelectorRequest): {cancel():void;close():void}&Observable<ExportPeopleForSelectorChunk>;
  exportPeopleForSelector(request: GetPeopleForSelectorRequest, metadata: grpc.Metadata): {cancel():void;close():void}&Observable<ExportPeopleForSelectorChunk>;
  exportPeopleForSelector(request: GetPeopleForSelectorRequest, onMessage: (message?: ExportPeopleForSelectorChunk) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;
  exportPeopleForSelector(request: GetPeopleForSelectorRequest, metadata: grpc.Metadata, onMessage: (message?: ExportPeopleForSelectorChunk) => void,onError?: (err: any) => void,onEnd?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): void;

  exportPeopleForSelector(request: GetPeopleForSelectorRequest, arg1?: grpc.Metadata|((message?: ExportPeopleForSelectorChunk) => void), arg2?: ((message?: ExportPeopleForSelectorChunk) => void)|((err: any) => void), arg3?: ((err: any) => void)|((code: number, msg: string|undefined, metadata: grpc.Metadata) => void), arg4?: (code: number, msg: string|undefined, metadata: grpc.Metadata) => void): {cancel():void;close():void}&Observable<ExportPeopleForSelectorChunk>|void {
    let ret: any;
    let metadata: any;

    let onMessage: any;
    let onError: any;
    let onEnd: any;
    if(typeof arg1 === 'function') {
      onMessage = arg1;
      onError = arg2;
      onEnd = arg3;
    } else if(typeof arg2 === 'function') {
      metadata = arg1;
      onMessage = arg2;
      onError = arg3;
      onEnd = arg4;
    } else {
      metadata = arg1;
    }

    if(!onMessage) {
      let subject = new Subject<ExportPeopleForSelectorChunk>();
      ret = subject.asObservable();

      onMessage = (response: any) => {
        subject.next(response);
      };

      onError = (err: any) => {
        subject.error(err);
      };

      onEnd = (code: any, msg: any, metadata: any) => {
        subject.complete();
      };

    } else {
      if(!onError) {
        onError = (err: any) => console.error(err);
      }

      if(!onEnd) {
        onEnd = (code: any, msg: any, metadata: any) => {};
      }
    }

    let req = grpc.invoke(__PeopleCollection.ExportPeopleForSelector, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onMessage: response => this._ngZone.run(() => {
        onMessage(response);
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code == grpc.Code.OK) {
          onEnd(code, msg, metadata);
        } else {
          let err = new Error(code + ' ' + (msg||''));
          (<any>err).code = code;
          onError(err);
        }
      })
    });

    (<any>ret).close = () => {
      console.warn('[Angular Grpc] .close() is deprecated use .cancel() instead');
      return req.close();
    };
    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getPeopleFromFile(request: GetPeopleFromFileRequest): Promise<GetPeopleFromFileResponse>;
  getPeopleFromFile(request: GetPeopleFromFileRequest, metadata: grpc.Metadata): Promise<GetPeopleFromFileResponse>;
  getPeopleFromFile(request: GetPeopleFromFileRequest, callback: (err: any|null, response: GetPeopleFromFileResponse, metadata: grpc.Metadata) => void): void;
  getPeopleFromFile(request: GetPeopleFromFileRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPeopleFromFileResponse, metadata: grpc.Metadata) => void): void;

  getPeopleFromFile(request: GetPeopleFromFileRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPeopleFromFileResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPeopleFromFileResponse, metadata: grpc.Metadata) => void): Promise<GetPeopleFromFileResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPeopleFromFileResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.GetPeopleFromFile, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getPersonByStudentId(request: GetPersonByStudentIdRequest): Promise<GetPersonByStudentIdResponse>;
  getPersonByStudentId(request: GetPersonByStudentIdRequest, metadata: grpc.Metadata): Promise<GetPersonByStudentIdResponse>;
  getPersonByStudentId(request: GetPersonByStudentIdRequest, callback: (err: any|null, response: GetPersonByStudentIdResponse, metadata: grpc.Metadata) => void): void;
  getPersonByStudentId(request: GetPersonByStudentIdRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPersonByStudentIdResponse, metadata: grpc.Metadata) => void): void;

  getPersonByStudentId(request: GetPersonByStudentIdRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPersonByStudentIdResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPersonByStudentIdResponse, metadata: grpc.Metadata) => void): Promise<GetPersonByStudentIdResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPersonByStudentIdResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.GetPersonByStudentId, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  summary(request: PeopleCollectionSummaryRequest): Promise<PeopleCollectionSummaryResponse>;
  summary(request: PeopleCollectionSummaryRequest, metadata: grpc.Metadata): Promise<PeopleCollectionSummaryResponse>;
  summary(request: PeopleCollectionSummaryRequest, callback: (err: any|null, response: PeopleCollectionSummaryResponse, metadata: grpc.Metadata) => void): void;
  summary(request: PeopleCollectionSummaryRequest, metadata: grpc.Metadata, callback: (err: any|null, response: PeopleCollectionSummaryResponse, metadata: grpc.Metadata) => void): void;

  summary(request: PeopleCollectionSummaryRequest, arg1?: grpc.Metadata|((err: any|null, response: PeopleCollectionSummaryResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: PeopleCollectionSummaryResponse, metadata: grpc.Metadata) => void): Promise<PeopleCollectionSummaryResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<PeopleCollectionSummaryResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeopleCollection.Summary, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

